import { BarLoader } from "react-spinners";

const CommonLoading = () => {
  return <BarLoader color="#181d26" height={5} width={100} />;
};

export default CommonLoading;
